import { Link } from 'react-router-dom';
import { articlesByCategory } from '@/mocks/articles';

export default function PhotosSection() {
  const photos = articlesByCategory('photos').slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100" aria-labelledby="photos-title">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs md:text-sm text-primary-500 font-medium tracking-widest mb-2">PHOTO GALLERY</p>
            <h2 id="photos-title" className="font-heading text-2xl md:text-3xl text-foreground-950">写真集锦</h2>
          </div>
          <Link
            to="/category/photos"
            className="flex items-center gap-1.5 text-sm text-secondary-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {photos.map((photo) => (
            <Link
              key={photo.slug}
              to={`/article/${photo.slug}`}
              className="group relative aspect-[3/4] overflow-hidden rounded-lg cursor-pointer"
            >
              <img
                src={photo.image}
                alt={photo.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <p className="text-background-50 text-sm font-medium line-clamp-2">{photo.title}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}